// @flow
import { createAction, handleActions } from 'redux-actions';

import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { getIdFromProps } from '~/core/state/selectors';

// ACTIONS
const CHANGE_PICKER = 'hive/bulbs/CHANGE_PICKER';
export const changePicker = createAction(CHANGE_PICKER);

// SELECTORS
const getBulbUi = state => state.bulbsUi;

export const getPickerNameForProduct = createSelector(getBulbUi, getIdFromProps, (bulbUi, id) => bulbUi.get(id));

// REDUCERS
export default handleActions(
    {
        [CHANGE_PICKER]: (state, { payload: { productId, pickerType } }) => {
            // $FlowFixMe
            return state.set(productId, pickerType);
        }
    },
    fromJS({})
);



// WEBPACK FOOTER //
// ./src/core/state/ui/bulbs/index.js